import './create-alteration-form.scss'

import { cloneDeep } from 'lodash'
import { defineComponent } from 'vue'
import { faPlus, faTimes } from '@fortawesome/free-solid-svg-icons'

import { Alteration, createTranslatedString } from '@skinsoft/types'
import { reactiveVueMixin } from "@skinsoft/reactive-vue"
import { EntitySelect } from '@skinsoft/ui'

export const ALTERATION_CREATED = 'global-alteration-created'

export default defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sEntitySelect: EntitySelect
    },
    props: [],
    template: require('./create-alteration-form.html'),
    data() {
        return {
            isEditing: false,
            newAlteration: {
                typeOfAlteration: '',
                precision: createTranslatedString(this.getAppLocale(), ''),
                media: '',
                drawing: '',
                title: createTranslatedString(this.getAppLocale(), ''),
                detailedViews: [],
            } as Alteration,

            addIcon: faPlus,
            closeIcon: faTimes,
        }
    },
    methods: {
        toggleEditing() {
            this.isEditing = !this.isEditing
        },

        onThesaurusTermSelected(entity: any) {
            if(entity.id) {
                this.newAlteration.typeOfAlteration = entity.id
            }
        },

        onSubmit() {
            this.$emit(ALTERATION_CREATED, cloneDeep(this.newAlteration))
            this.newAlteration = {
                typeOfAlteration: '',
                precision: createTranslatedString(this.getAppLocale(), ''),
                media: '',
                drawing: '',
                title: createTranslatedString(this.getAppLocale(), ''),
                detailedViews: [],
            }
        },
    },
})
